import { render } from "./Notifications.vue?vue&type=template&id=14349b31&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=14349b31&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14349b31"

export default script